import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

interface UnitType {
  name: string;
  area: string;
  price: string;
  available: string;
}

@Component({
  selector: 'app-unit-types',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div
      class="surface-card rounded-3xl p-6 md:p-8 antialiased"
    >
      <div class="flex items-center justify-between mb-6 pb-2 border-b border-border-subtle">
        <div class="flex items-center gap-2">
          <div class="w-1.5 h-3.5 bg-primary rounded-sm shadow-sm"></div>
          <h2 class="text-sm font-black text-text-primary uppercase tracking-wider font-mono">
            {{ 'projectsDetails.availableUnitTypes' | translate }}
          </h2>
        </div>

        <span
          class="px-2.5 py-1 bg-surface-elevated border border-border rounded-lg text-[10px] font-mono font-bold text-text-muted"
        >
          {{ unitTypes.length }} {{ 'projectsDetails.architecturalModels' | translate }}
        </span>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        @for (unit of unitTypes; track unit.name) {
          <div
            class="group border border-border bg-surface-elevated/40 hover:bg-surface-elevated rounded-2xl p-5 hover:border-border-primary hover:shadow-elevated hover:-translate-y-0.5 transition-all duration-300 flex flex-col justify-between"
          >
            <div class="flex items-center gap-3 mb-4.5">
              <div
                class="w-9 h-9 bg-surface rounded-xl flex items-center justify-center text-primary border border-border shadow-inner shrink-0 group-hover:scale-105 transition-transform"
              >
                <i [class]="getUnitIcon(unit.name)" class="text-xs"></i>
              </div>
              <h3
                class="text-xs md:text-sm font-black text-text-primary tracking-tight font-mono uppercase"
              >
                {{ unit.name }}
              </h3>
            </div>

            <div class="space-y-3 pt-3 border-t border-border-subtle">
              <div class="flex justify-between items-center text-xs">
                <span class="font-medium text-text-muted">{{ 'projectsDetails.totalArea' | translate }}</span>
                <span class="font-mono font-bold text-text-secondary tracking-tight">{{
                  unit.area
                }}</span>
              </div>

              <div class="flex justify-between items-center text-xs">
                <span class="font-medium text-text-muted">{{ 'projectsDetails.startingPrice' | translate }}</span>
                <span class="font-mono font-black text-primary text-[13px] tracking-tight">{{
                  unit.price
                }}</span>
              </div>

              <div class="flex justify-between items-center text-xs pt-1">
                <span class="font-medium text-text-muted">{{ 'projectsDetails.availableStock' | translate }}</span>
                <span
                  class="px-2 py-0.5 bg-primary-soft border border-primary/20 text-primary font-mono font-bold text-[10px] rounded-md tracking-wider uppercase"
                >
                  {{ unit.available }}
                </span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class UnitTypesComponent {
  @Input() unitTypes: UnitType[] = [];

  /**
   * دالة ذكية لتحليل اسم الوحدة وإرجاع الأيقونة المعمارية المناسبة لها
   */
  getUnitIcon(name: string): string {
    const text = name.toLowerCase();

    if (text.includes('apartment') || text.includes('flat')) {
      return 'fa-solid fa-building-user';
    }
    if (text.includes('duplex') || text.includes('twin')) {
      return 'fa-solid fa-layer-group';
    }
    if (text.includes('penthouse') || text.includes('roof') || text.includes('sky')) {
      return 'fa-solid fa-cloud-sun';
    }
    if (text.includes('villa') || text.includes('townhouse')) {
      return 'fa-solid fa-house-chimney-window';
    }

    return 'fa-solid fa-house-user';
  }
}
